module.exports = __webpack_public_path__ + "img/appointment.10cc0223.svg";